export { default as ImgGradeBad } from './img-grade-bad.png';
export { default as ImgGradeExcellent } from './img-grade-excellent.png';
export { default as ImgGradeGood } from './img-grade-good.png';
